import { useState } from 'react';

const useModal = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState({ title: '', content: '' });
  const [onCloseCallback, setOnCloseCallback] = useState(null);

  const openModal = (title, content, onClose) => {
    setModalContent({ title, content });
    setIsModalVisible(true);
    if (onClose) setOnCloseCallback(() => onClose);
  };

  const closeModal = () => {
    setIsModalVisible(false);
    if (onCloseCallback) {
      onCloseCallback();
      setOnCloseCallback(null); // reset after use
    }
  };

  return {
    isModalVisible,
    modalContent,
    openModal,
    closeModal,
  };
};

export default useModal;
